/**
 * Generated bundle index. Do not edit.
 */
export { Modal, VEXModalContext, VEXModalContextBuilder, DropInPreset, DropInPresetBuilder, DialogFormModal, FormDropIn, VEXDialogButtons, DialogPreset, DialogPresetBuilder, VexModalModule, providers } from './vex';
//# sourceMappingURL=angular2-modal-vex.ng-flat.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/plugins/vex/src/angular2-modal-vex.ng-flat.js
// module id = 18
// module chunks = 0